<template lang="pug">
.xs-12.compare-tips
  .fixed-width-tweak-upper
    .compare-tip-wrap.xs-12(v-if="tipOne || tipTwo")
      .compare-tip.one(:class="{ninja: !tipOne}")
        p.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak(v-if="tips[tipOne]" v-html="tips[tipOne]")
      .compare-tip.two(:class="{ninja: !tipTwo}")
        p.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak(v-if="tips[tipTwo]" v-html="tips[tipTwo]")
    .compare-tip-fallback(v-if="productOne && productTwo && !productOne.compareTip && !productTwo.compareTip")
      p.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak(v-html="tips.fallback")

</template>
<script>
  export default {
    name: 'CompareTips',
    inject: ['getObjProperty'],
    props: {
      productOne: {
        type: Object,
        default: () => ({}),
      },
      productTwo: {
        type: Object,
        default: () => ({}),
      },
      tips: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      tipOne() {
        return this.getObjProperty(this, 'productOne.compareTip');
      },
      tipTwo() {
        return this.getObjProperty(this, 'productTwo.compateTip');
      },
    },
  };
</script>